// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"335":"b019f76f","359":"0d6c399b","529":"4cb407a4"}[chunkId] + ".chunk.js";
};